import { toast } from "react-toastify";

export default class ToastService {
    showSuccess(message: string) {
        toast.success(message, {
            position: "top-right",
            className: "toast-message",
        });
    }

    showError(message: string) {
        toast.error(message, {
            position: "top-right",
            className: "toast-message",
        });
    }

    showWarning(message: string) {
        toast.warning(message, {
            position: "top-right",
            className: "toast-message",
        });
    }

    showInfo(message: string) {
        toast.info(message, {
            position: "top-right",
            className: "toast-message",
        });
    }
}